// Documentation: https://kkmserver.ru/KkmServer#Primer

import store from "@/store"
import { getCountryNumber } from "@/services/country.helper"
import { padString } from "@/services/text.service"
import { generateUUIDV4 } from "@/services/jwt.service"

const defaultUrlServer = "http://localhost:5893"; // HTTP адрес сервера торгового оборудования, если пусто то локальный вызов
const User = "";      // Пользователь доступа к серверу торгового оборудования
const Password = "";  // Пароль доступа к серверу торгового оборудования

const KKMExecuteCommand = async (params) => {

	params.IdCommand = generateUUIDV4()
	const user = store?.state?.auth?.user
	const branchId = store?.state?.auth?.branch || '0'
	const cashierType = store.getters.dynamicConfigValue('kkm_cashier_type', branchId) || 'auto'
	let cashierName, cashierINN
	if(cashierType === 'fixed') {
		cashierName = store.getters.dynamicConfigValue('kkm_cashier_name', branchId) || ''
		cashierINN = store.getters.dynamicConfigValue('kkm_cashier_inn', branchId) || ''
	} else {
		cashierName = user?.full_name || ''
		cashierINN = user?.taxcode || ''
	}
	const kkmUrl = store.getters.dynamicConfigValue('kkm_url', branchId) || defaultUrlServer
	params.CashierName = cashierName
	params.CashierVATIN = cashierINN

	const url = `${kkmUrl}/Execute`;
	const basicAuth = (User !== '' || Password !== '') ? ('Basic ' + btoa(User + ':' + Password)) : '';
	try {
		const response = await fetch(
				url,
				{
					method: 'POST',
					mode: 'cors',
					cache: 'no-cache',
					//credentials: 'same-origin', // include, *same-origin, omit
					headers: {
						'Content-Type': 'application/json; charset=UTF-8',
						'Authorization': basicAuth
					},
					redirect: 'follow',
					referrerPolicy: 'no-referrer',
					body: JSON.stringify(params)
				}
		)
		const jsonRes = await response.json()
		const status = jsonRes.Status
		if (status === 0) { // 0 - ok, 1 - Выполняется, 2 - Ошибка, 3 - Данные не найдены
			return { data: jsonRes, error: null }
		}
		return { data: jsonRes, error: jsonRes.Error || jsonRes.Warning }
	} catch (e) {
		return { data: null, error: e }
	}
}

const KKMService = {
	async openShift() {
		return await KKMExecuteCommand({
			Command: "OpenShift",
			// ИНН ККМ для поиска. Если "" то ККМ ищется только по NumDevice,
			// Если NumDevice = 0 а InnKkm заполнено то ККМ ищется только по InnKkm
			InnKkm: "",
			// Система налогообложения (СНО) для поиска ККТ, Можно не указывать, или = "" - любое СНО
			TaxVariant: "",
			// Номер устройства. Если 0 то первое не блокированное на сервере
			// Не рекомендовано для использования.
			// Рекомендуем для поиска ККТ задавать InnKkm и TaxVariant !!!!!!
			NumDevice: 0,
			// Id устройства. Строка. Если = "" то первое не блокированное на сервере
			IdDevice: "",
			// Не печатать чек на бумагу
			NotPrint: false,
		})
	},
	async closeShift() {
		return await KKMExecuteCommand({
			Command: "CloseShift",
			// ИНН ККМ для поиска. Если "" то ККМ ищется только по NumDevice,
			// Если NumDevice = 0 а InnKkm заполнено то ККМ ищется только по InnKkm
			InnKkm: "",
			// Система налогообложения (СНО) для поиска ККТ, Можно не указывать, или = "" - любое СНО
			TaxVariant: "",
			// Номер устройства. Если 0 то первое не блокированное на сервере
			// Не рекомендовано для использования.
			// Рекомендуем для поиска ККТ задавать InnKkm и TaxVariant !!!!!!
			NumDevice: 0,
			// Id устройства. Строка. Если = "" то первое не блокированное на сервере
			IdDevice: "",
			// Не печатать чек на бумагу
			NotPrint: false,
		})
	},
	async printXReport() {
		return await KKMExecuteCommand({
			Command: "XReport",
			// ИНН ККМ для поиска. Если "" то ККМ ищется только по NumDevice,
			// Если NumDevice = 0 а InnKkm заполнено то ККМ ищется только по InnKkm
			InnKkm: "",
			// Система налогообложения (СНО) для поиска ККТ, Можно не указывать, или = "" - любое СНО
			TaxVariant: "",
			// Номер устройства. Если 0 то первое не блокированное на сервере
			// Не рекомендовано для использования.
			// Рекомендуем для поиска ККТ задавать InnKkm и TaxVariant !!!!!!
			NumDevice: 0,
		})
	},
	async depositToCashdesk(amount) {
		return await KKMExecuteCommand({
			Command: "DepositingCash",
			// ИНН ККМ для поиска. Если "" то ККМ ищется только по NumDevice,
			// Если NumDevice = 0 а InnKkm заполнено то ККМ ищется только по InnKkm
			InnKkm: "",
			// Система налогообложения (СНО) для поиска ККТ, Можно не указывать, или = "" - любое СНО
			TaxVariant: "",
			// Номер устройства. Если 0 то первое не блокированное на сервере
			// Не рекомендовано для использования.
			// Рекомендуем для поиска ККТ задавать InnKkm и TaxVariant !!!!!!
			NumDevice: 0,
			// Сумма внесения наличных
			// Сумма внесения наличных
			Amount: amount,
		})
	},
	async withdrawFromCashdesk(amount) {
		return await KKMExecuteCommand({
			Command: "PaymentCash",
			// ИНН ККМ для поиска. Если "" то ККМ ищется только по NumDevice,
			// Если NumDevice = 0 а InnKkm заполнено то ККМ ищется только по InnKkm
			InnKkm: "",
			// Система налогообложения (СНО) для поиска ККТ, Можно не указывать, или = "" - любое СНО
			TaxVariant: "",
			// Номер устройства. Если 0 то первое не блокированное на сервере
			// Не рекомендовано для использования.
			// Рекомендуем для поиска ККТ задавать InnKkm и TaxVariant !!!!!!
			NumDevice: 0,
			// Сумма внесения наличных
			// Сумма внесения наличных
			Amount: amount,
		})
	},
	async printCheque({
											payId,
											amount,
											payMethod,
											services,
											totalPrice,
											totalPaid,
											numDevice,
											transactionType = 'payForVisit',
											paymentFor = 'visit',
											email,
											paymentsDetailed = [],
											bonus = 0,
											materialsForSale = [],
										}) {
		// console.log({
		// 	payId,
		// 	amount,
		// 	payMethod,
		// 	services,
		// 	totalPrice,
		// 	totalPaid,
		// 	numDevice,
		// 	transactionType,
		// 	paymentFor,
		// 	email,
		// 	paymentsDetailed,
		// 	bonus
		// })
		const branchId = store?.state?.auth?.branch || '0'
		const wayToHandleAdvance = store.getters.dynamicConfigValue('kkm_advance', branchId) || 'advance'

		if(!paymentsDetailed || !paymentsDetailed.length) {
			paymentsDetailed = [{ amount: amount, payMethodId: payMethod }]
		}
		const recordFullyPaid = totalPaid >= totalPrice
		const isPartialPayment = (amount + bonus) < totalPrice
		const isFirstPayment = (totalPaid - amount - bonus) <= 0
		const originalAmount = amount
		let isAdvance = isPartialPayment && !recordFullyPaid
		let previousAdvances = recordFullyPaid && isPartialPayment ? (totalPaid - amount - bonus) : 0
		if(wayToHandleAdvance === 'credit') {
			previousAdvances = 0
		}
		let paidUsingDeposit = false
		let credit = 0
		paymentsDetailed.forEach((payment) => {
			const tmpPaidUsingDeposit = payment.payMethodId === 5 || payment.payMethodId === 100 // 5 is deposit, 100 - family account
			if(tmpPaidUsingDeposit) {
				previousAdvances += payment.amount
				amount -= payment.amount
				paidUsingDeposit = true
			}
		})
		const countryNumber = getCountryNumber(store?.state?.auth?.clinic?.country_id || '3')
		const cashMethods = (store.getters.dynamicConfigValue('kkm_cashmethods', branchId) || []).map(Number)
		let serviceName = store.getters.dynamicConfigValue('kkm_service', branchId) || ''

		if(isAdvance) serviceName = `Аванс, ${serviceName}`
		if(transactionType === 'depositFill') {
			isAdvance = true
			serviceName = 'Пополнение депозита'
		}
		if(transactionType === 'depositWithdrawal') {
			isAdvance = true
			serviceName = 'Возврат депозита'
		}
		if(transactionType === 'refund') {
			serviceName = 'Возврат за услуги'
		}
		if(paymentFor === 'material') {
			serviceName = 'Продажа товаров'
		}
		const clinicName = store.getters.dynamicConfigValue('kkm_clinic_name', branchId) || ''
		const sendServices = Number(store.getters.dynamicConfigValue('kkm_send_services', branchId) || 0) === 1 && transactionType === 'payForVisit'
		const taxMode = store.getters.dynamicConfigValue('kkm_vat', branchId) || ''
		let cashAmount = 0
		paymentsDetailed.forEach((payment) => {
			if(cashMethods.includes(payment.payMethodId)) {
				cashAmount += payment.amount
			}
		})
		const nonCashAmount = amount - cashAmount
		const rows = [ // Строки чека
			{
				PrintText: {
					Text: ">#2#<"+clinicName, //При вставке в текст символов ">#10#<" строка при печати выровнеется по центру, где 10 - это на сколько меньше станет строка ККТ
					Font: 1,
				},
			},
			{ PrintText: { Text: "<<->>" }, },
			{ PrintText: { Text: "<<*>>" }, }
		]

		if(!sendServices && previousAdvances > 0 && recordFullyPaid && !paidUsingDeposit && wayToHandleAdvance !== 'credit') {
			amount = totalPaid
		}

		let showServicesLineByLine = sendServices && (recordFullyPaid || wayToHandleAdvance === 'prepayment')
		if(wayToHandleAdvance === 'credit' && isPartialPayment) {
			showServicesLineByLine = isFirstPayment  // для кредита показываем услуги по строкам для первой предоплаты
			if(isFirstPayment) {
				credit = Math.max(0, totalPrice - amount - previousAdvances - bonus)
			} else {
				serviceName = 'Оплата кредита'
			}
		}
		// if(paymentFor === 'materials') {
		// 	showServicesLineByLine = false
		// }

		if(paidUsingDeposit && recordFullyPaid && !showServicesLineByLine && !isPartialPayment) { // for situation where we show one line and use amount for it and it can be zero because we substracted it before.
			amount = totalPaid
		}
		if((paidUsingDeposit || bonus > 0) && !showServicesLineByLine && (wayToHandleAdvance === 'credit' || wayToHandleAdvance === 'advance')) {
			amount = originalAmount + bonus
		}
		// const showServicesLineByLine = sendServices && recordFullyPaid
		if(!showServicesLineByLine) { // true for all non-standard transaction types (!= payForVisit)
			rows.push(addChequeLine(serviceName, amount, 1, amount, taxMode, countryNumber, isAdvance, isPartialPayment, isFirstPayment, paymentFor))
		}
		if(showServicesLineByLine) {
			let lineByLineAmount = 0
			let generalDiscountCoefficient = 1
			const servicesArray = Object.values(services)
			const servicesQty = {}
			if(paymentFor === 'material') {
				materialsForSale.forEach((material) => {
					lineByLineAmount += Math.round(Number(material.amount) * material.sale_price * 100) / 100
				})
			} else {
				servicesArray.forEach((service) => {
					const serviceId = Number(service.id)
					const servicePrice = priceOfService(service)
					lineByLineAmount += Math.round(servicePrice * (service.teeth?.length || 1) * 100) / 100
					if(!servicesQty[serviceId]) servicesQty[serviceId] = 0
					if(service.teeth) {
						servicesQty[serviceId] += (service.teeth?.length || 0)
					} else {
						servicesQty[serviceId] += 1
					}
				})
			}

			if(lineByLineAmount > totalPrice) {
				generalDiscountCoefficient = totalPrice / lineByLineAmount
			}
			lineByLineAmount = 0
			if(paymentFor === 'material') {
				materialsForSale.forEach((material) => {
					const discountedAmount = Math.round(Number(material.amount) * material.sale_price * 100 * generalDiscountCoefficient) / 100
					lineByLineAmount += discountedAmount
					rows.push(addChequeLine(material.title, material.sale_price, Number(material.amount), discountedAmount, taxMode, countryNumber, isAdvance, isPartialPayment, isFirstPayment, paymentFor))
				})
			} else {
				const servicesAdded = []
				servicesArray.forEach((service) => {
					const serviceId = Number(service.id)
					const quantity = servicesQty[serviceId] || 0
					if(quantity > 0 && !servicesAdded.includes(serviceId)) {
						const priceOriginal = Number(service.pivot?.price_original || service.price_original)
						const price = priceOfService(service)
						const discountedAmount = Math.round(price * quantity * 100 * generalDiscountCoefficient) / 100
						const specificServiceName = service.russian_classificator_service ? `${service.russian_classificator_service.code}. ${service.russian_classificator_service.title}` : (service.cod ? `${service.cod} ` : '') + service.name
						lineByLineAmount += discountedAmount
						rows.push(addChequeLine(specificServiceName, priceOriginal, quantity, discountedAmount, taxMode, countryNumber, isAdvance, isPartialPayment, isFirstPayment, paymentFor))
						servicesAdded.push(serviceId)
					}
				})
			}

			if(lineByLineAmount != totalPrice) { // because of rounding
				const adjustment = (Math.round((totalPrice - lineByLineAmount) * 100) / 100)
				if(rows[(rows.length - 1)].Register) {
					rows[(rows.length - 1)].Register.Amount += adjustment
					if(rows[(rows.length - 1)].Register.Amount === null) {
						rows[(rows.length - 1)].Register.Amount = 0
					}
				}
			}
		}
		const data = {
			Command: "RegisterCheck",
			InnKkm: "",
			TaxVariant: "",
			NumDevice: numDevice || 0,
			IsFiscalCheck: true,
			TypeCheck: transactionType === 'depositWithdrawal' || transactionType === 'refund' ? 1 : 0, // 0 – продажа/приход; 1 – возврат продажи/прихода; 2 – корректировка продажи/прихода; 3 – корректировка возврата продажи/прихода; (>=ФФД 1.1); 10 – покупка/расход; 11 - возврат покупки/расхода; 12 – корректировка покупки/расхода; 13 – корректировка возврата покупки/расхода; (>=ФФД 1.1)
			NotPrint: false, // Не печатать чек на бумагу
			NumberCopies: 0,  // Количество копий документа
			ClientAddress: email || "", // Телефон или е-Майл покупателя, Тег ОФД 1008, Если чек не печатается (NotPrint = true) то указывать обязательно, Формат: Телефон +{Ц} или Email {С}@{C}
			ClientInfo: "", // Покупатель (клиент) - наименование организации или фамилия, имя, отчество (при наличии), серия и номер паспорта покупателя(клиента). Тег 1227
			ClientINN: "", // ИНН покупателя (клиента). Тег 1228
			SenderEmail: "", // Aдрес электронной почты отправителя чека, Тег ОФД 1117 (если задан при регистрации можно не указывать)
			AddressSettle: "", // Адрес расчетов, Тег ОФД 1009 (если не задано - берется из регистрационных данных ККТ)
			PlaceMarket: "", // Место расчетов, Тег ОФД 1187 (если не задано - берется из регистрационных данных ККТ)
			PayByProcessing: false, //В тестовом чеке автоматический эквайринг выключен
			NumDeviceByProcessing : null, // Номер устройства для эквайринга - Null - из настроек на сервере, 0 - любое, число - номер конкретного устройства
			ReceiptNumber: payId, // Номер чека для эквайринга
			PrintSlipAfterCheck: false, // Печатать Слип-чек после чека (а не в чеке)
			PrintSlipForCashier: true, // Печатать Слип-чек дополнительно для кассира (основной слип-чек уже будет печататся в составе чека)
			// UserAttribute: { // Дополнительный реквизит пользователя тег ОФД 1084
			// 	Name: "", // Наименование дополнительного реквизита пользователя тег ОД 1085
			// 	Value: "" // Значение дополнительного реквизита пользователя тег ОФД 1086
			// },
			AdditionalAttribute: "", // Дополнительный реквизит чека тег 1192
			CheckStrings: rows, // Строки чека
			Cash: cashAmount, // Наличная оплата (2 знака после запятой), Тег 1031
			ElectronicPayment: nonCashAmount, // Сумма электронной оплаты (2 знака после запятой), Тег 1081
			AdvancePayment: previousAdvances, // Сумма из предоплаты (зачетом аванса) (2 знака после запятой), Тег 1215
			Credit: credit, // Сумма постоплатой(в кредит) (2 знака после запятой), Тег 1216
			CashProvision: bonus, // Сумма оплаты встречным предоставлением (сертификаты, др. мат.ценности) (2 знака после запятой), Тег 1217
			// Только для чеков коррекции
			// CorrectionType: 1, // Тип коррекции 0 - самостоятельно 1 - по предписанию, Тег 1173, Только для чеков коррекции!
			// Дата документа основания для коррекции, Тег ОФД 1178, Только для чеков коррекции!
			// CorrectionBaseDate: '2017-06-21T15:30:45',
			// Номер документа основания для коррекции, Тег ОФД 1179, Только для чеков коррекции!
			// CorrectionBaseNumber: "MOS-4516",
		}
		// console.log(data)
		return await KKMExecuteCommand(data);
	},
	async getKKMInfo() {
		return await KKMExecuteCommand({
			Command: "GetDataKKT",
			// ИНН ККМ для поиска. Если "" то ККМ ищется только по NumDevice,
			// Если NumDevice = 0 а InnKkm заполнено то ККМ ищется только по InnKkm
			InnKkm: "",
			// Система налогообложения (СНО) для поиска ККТ, Можно не указывать, или = "" - любое СНО
			TaxVariant: "",
			// Номер устройства. Если 0 то первое не блокированное на сервере
			// Не рекомендовано для использования.
			// Рекомендуем для поиска ККТ задавать InnKkm и TaxVariant !!!!!!
			NumDevice: 0
		});
	},
	async printChequeCopy(checkNum) {
		return await KKMExecuteCommand({
			Command: "GetDataCheck",
			InnKkm: "",
			TaxVariant: "",
			NumDevice: 0,
			FiscalNumber: checkNum || 0,
			// NumberCopies: 1
		});
	},
	async payByPaymentCard(amount, numDevice, inn = "") {
		return await KKMExecuteCommand({
			Command: "PayByPaymentCard",
			// ИНН ККМ для поиска. Если "" то ККМ ищется только по NumDevice,
			// Если NumDevice = 0 а InnKkm заполнено то ККМ ищется только по InnKkm
			InnKkm: inn,
			// Система налогообложения (СНО) для поиска ККТ, Можно не указывать, или = "" - любое СНО
			TaxVariant: "",
			// Номер устройства. Если 0 то первое не блокированное на сервере
			// Не рекомендовано для использования.
			// Рекомендуем для поиска ККТ задавать InnKkm и TaxVariant !!!!!!
			NumDevice: numDevice || 0,
			Amount: amount,
		});
	},
	async returnPaymentByPaymentCard(amount, numDevice, universalId, inn = "") {
		return await KKMExecuteCommand({
			Command: "ReturnPaymentByPaymentCard",
			// ИНН ККМ для поиска. Если "" то ККМ ищется только по NumDevice,
			// Если NumDevice = 0 а InnKkm заполнено то ККМ ищется только по InnKkm
			InnKkm: inn,
			// Система налогообложения (СНО) для поиска ККТ, Можно не указывать, или = "" - любое СНО
			TaxVariant: "",
			// Номер устройства. Если 0 то первое не блокированное на сервере
			// Не рекомендовано для использования.
			// Рекомендуем для поиска ККТ задавать InnKkm и TaxVariant !!!!!!
			NumDevice: numDevice || 0,
			Amount: amount,
			UniversalID: universalId
		});
	},
	async getDevices() {
		return await KKMExecuteCommand({
			Command: "List",
			Active: true,
		});
	},
	async closeShiftByCard(numDevice = null) { // Закрыть смену по картам
		return await KKMExecuteCommand({
			Command: "Settlement",
			InnKkm: "",
			NumDevice: numDevice || 0,
		});
	},
	async terminalReport(numDevice = null) { // Получить итоги дня по картам
		return await KKMExecuteCommand({
			Command: "TerminalReport",
			InnKkm: "",
			NumDevice: numDevice || 0,
			Detailed: true, // Краткий (false) или полный (true) отчет
		});
	},
}
export default KKMService

function addChequeLine(name, amount, quantity, discountedAmount, taxMode, countryNumber, isAdvance = false, isPartialPayment = false, isFirstPayment = false, paymentFor = 'visit') {
	// console.log({ name, amount, quantity, discountedAmount, taxMode, countryNumber, isAdvance, isPartialPayment, isFirstPayment, paymentFor });
	if(discountedAmount === 'null' || discountedAmount === null) {
		discountedAmount = 0
	}
	const branchId = store?.state?.auth?.branch || '0'
	const wayToHandleAdvance = store.getters.dynamicConfigValue('kkm_advance', branchId) || 'advance'
	let signMethodCalculation = isAdvance ? (wayToHandleAdvance === 'prepayment' ? 2 : 3) : 4 // Признак способа расчета. Тег ОФД 1214. Для ФФД.1.05 и выше обязательное поле, 2: "ПРЕДОПЛАТА (Частичная предварительная оплата до момента передачи предмета расчета)", 3: "АВАНС", 4: "ПОЛНЫЙ РАСЧЕТ (Полная оплата, в том числе с учетом аванса в момент передачи предмета расчета)", 5: "ЧАСТИЧНЫЙ РАСЧЕТ И КРЕДИТ (Частичная оплата предмета расчета в момент его передачи с последующей оплатой в кредит )", 7: "ОПЛАТА КРЕДИТА (Оплата предмета расчета после его передачи с оплатой в кредит )"
	let signCalculationObject = isAdvance ? 10 : (paymentFor === 'material' ? 1 : 4) // Признак предмета расчета. Тег ОФД 1212. Для ФФД.1.05 и выше обязательное поле, 4 - "УСЛУГА (наименование и иные сведения, описывающие услугу), 10: "ПЛАТЕЖ (аванс, задаток, предоплата, кредит, взнос в счет оплаты, пени, штраф, вознаграждение, бонус и иной аналогичный предмет расчета)", 1: "ТОВАР (наименование и иные сведения, описывающие товар)"
	if(wayToHandleAdvance === 'credit' && isPartialPayment && paymentFor === 'visit') {
		signMethodCalculation = isFirstPayment ? 5 : 7
		signCalculationObject = isFirstPayment ? 4 : 10
	}
	return {
		Register: {
			Name: padString(name, 64), // Наименование товара 64 символа, Тег 1059
			Quantity: quantity || 0, // Количество товара (3 знака после запятой), Тег 1023
			Price: amount || 0, // Цена за шт. без скидки (2 знака после запятой)
			Amount: discountedAmount || 0, // Конечная сумма строки с учетом всех скидок /наценок; (2 знака после запятой), Из нее расчет тега 1079
			Department: 0, // Отдел, по которому ведется продажа
			Tax: taxMode, // НДС в процентах или ТЕГ НДС: 0 (НДС 0%), 10 (НДС 10%), 20 (НДС 20%), -1 (НДС не облагается), 120 (НДС 20 /120), 110 (НДС 10 /110), Тег 1043, Из нее расчет тега 1079
			SignMethodCalculation: signMethodCalculation, // Признак способа расчета. Тег ОФД 1214. Для ФФД.1.05 и выше обязательное поле, 2: "ПРЕДОПЛАТА (Частичная предварительная оплата до момента передачи предмета расчета)", 3: "АВАНС", 4: "ПОЛНЫЙ РАСЧЕТ (Полная оплата, в том числе с учетом аванса в момент передачи предмета расчета)", 5: "ЧАСТИЧНЫЙ РАСЧЕТ И КРЕДИТ (Частичная оплата предмета расчета в момент его передачи с последующей оплатой в кредит )"
			SignCalculationObject: signCalculationObject, // Признак предмета расчета. Тег ОФД 1212. Для ФФД.1.05 и выше обязательное поле, 4 - "УСЛУГА (наименование и иные сведения, описывающие услугу), 10: "ПЛАТЕЖ (аванс, задаток, предоплата, кредит, взнос в счет оплаты, пени, штраф, вознаграждение, бонус и иной аналогичный предмет расчета)", 1: "ТОВАР (наименование и иные сведения, описывающие товар)"
			MeasureOfQuantity: 0, // 0 шт.или ед.; 10 г; 11 кг; 12 т; 20 см; 21 дм; 22 м; 30 кв.см; 31 кв.дм; 32 кв.м; 40	мл; 41 л; 42 куб.м; 50 кВт ч; 51 Гкал; 70 сутки; 71 час; 72 мин; 73 с; 80 Кбайт; 81 Мбайт; 82 Гбайт; 83 Тбайт; 255 Прочее
			PackageQuantity: null, // Общее количество товара в упаковке(тег 1294) Передавать ТОЛЬКО при продаже товара из упаковки маркировки!!
			CountryOfOrigin: countryNumber, // Цифровой код страны происхождения товара в соответствии с Общероссийским классификатором стран мира 3 симв. Тег 1230
			CustomsDeclaration: "" , // Регистрационный номер таможенной декларации 32 симв. Тег 1231
			ExciseAmount: null, // Сумма акциза с учетом копеек, включенная в стоимость предмета расчета Тег 1229, Иначе сумма акциза
			AdditionalAttribute: "", // Дополнительный реквизит предмета расчета тег 1191, Только для ФФД 1.1 !
		},
	}
}

function priceOfService(service) {
	let servicePrice = service.pivot?.price || service.total_cost
	if(servicePrice === undefined && service.pivot) {
		const serviceDiscount = service.pivot.discount_type === 'percent' ? ((service.pivot.discount / 100) * service.pivot.price_original) : service.pivot.discount
		servicePrice = Number(service.pivot.price_original) - serviceDiscount
	}
	return Math.round((servicePrice || 0) * 100) / 100
}
